import { Field, Form, Formik, FormikValues } from 'formik';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { deserialize, serialize } from 'serializr';
import { MetaModel } from '../../../../../models/CourseModels/SubjectModel/subject.model';
import {
  BranchClassRoomsModel,
  BranchMetaModel,
} from '../../../../../models/InstituteModel/branches.model';
import { Students, StudentCreateModel } from '../../../../../models/InstituteModel/students.model';
import BranchService from '../../../../../services/InstituteService/branch.service';
import SectionService from '../../../../../services/InstituteService/section.service';
import DropdownField from '../../../../../shared/components/DropdownField';
import InputField from '../../../../../shared/components/InputField';
import ToggleSwitch from '../../../../../shared/components/ToggleSwitch';
import UIModal from '../../../../../shared/components/UIModal';
import { StudentValidationSchema } from '../../../instituteFormValidation';
import './instituteStudentForm.scss';
import DatePickerField from '../../../../../shared/components/DatePickerField';
import BoardService from '../../../../../services/CourseServices/BoardService/board.service';
import { BoardMetaModel } from '../../../../../models/CourseModels/BoardModel/board.model';
import StudentService from '../../../../../services/StudentService/student.service';

interface InstituteStudentFormProps {
  visible: boolean;
  closeHandler: () => void;
  data?: Students;
  refreshList: () => void;
  apiMethod: () => void;
}

const InstituteStudentForm: FC<InstituteStudentFormProps> = (props) => {
  const { visible, closeHandler, data, apiMethod } = props;
  const [initialValues, setInitialValues] = useState<any>();
  const formRef = useRef<any>();
  const [branches, setBranches] = useState<any>();
  const [branchClassRoomsMeta, setBranchClassRoomsMeta] = useState<MetaModel[]>(
    []
  );
  const [loading, setLoading] = useState(false);
  const [boards, setBoards] = useState<any>([]);
  const [sections, setSections] = useState<any>([]);
  const params: any = useParams();


  const fetchBranches = (boardId: any) => {
    BranchService.fetchBranches(

      { board_id: boardId, institute_id: params?.instituteId },
      (data) => {
        let meta: any = deserialize(BranchMetaModel, data);
        setBranches([...meta]);
      },
      () => {},
      () => {}
    );
  };

  const fetchSections = (id: any) => {
    SectionService.fetchSectionsMeta(
      { branch_class_room_id: id },
      (sections) => {

        setSections(sections);
      },
      () => {},
      () => {}
    );
  };

  const fetchBoards = () => {
    BoardService.getBoardsList(
      '',
      (response) => {
        let boards = deserialize(BoardMetaModel, response);
        setBoards(boards);
      },
      () => {},
      () => {}
    );
  };

  const fetchBranchClassRooms = (id: any) => {
    SectionService.fetchBranchClassRooms(
      { branch_id: id },
      (classrooms: BranchClassRoomsModel[]) => {
        const meta = deserialize(MetaModel, classrooms) as MetaModel[];
        setBranchClassRoomsMeta(meta);
      },
      () => {},
      () => {}
    );
  };

  useEffect(() => {
    if (data?.branch?.id) {
      fetchSections(data?.branch?.id);
      fetchBranchClassRooms(data?.branch?.id);
    }

    if (data?.board?.id) {
      fetchBranches(data.board.id);
    }

    if (data?.branch?.id) {
      fetchBranchClassRooms(data?.branch?.id);
    }

    if (data?.section?.branchClassRoomId) {
      fetchSections(data?.section?.branchClassRoomId)
    }

    setInitialValues({
      id: data?.id,
      isBlocked: data?.isBlocked || false,
      firstName: data?.name,
      dob: data?.dob,
      email: data?.email,
      rollNumber: data?.rollNumber,
      sectionId: data?.section?.id,
      branchId: data?.branch?.id,
      boardId: data?.board?.id,
      branchClassRoomId: data?.section?.branchClassRoomId,
      phoneNumber: data?.phoneNumber,
      password: ''
    });

    fetchBoards();
  }, [data]);

  const onSubmit = (values: FormikValues) => {
    setLoading(true);

    const jsonPayload = serialize(StudentCreateModel, {
      ...values,
    });

    if (data?.id) {
      StudentService.updateStudent(
        data?.id,
        jsonPayload,
        () => {
          formRef.current.resetForm({ values: null });
          closeHandler();
          apiMethod();
          setLoading(false);

        },
        (errors: any) => {
          // setUploadErrors(errors);
        },
        () => {
          setLoading(false);
        }
      );
    } else {
      StudentService.createStudent(
        jsonPayload,
        () => {
          formRef.current.resetForm({ values: null });
          closeHandler();
          apiMethod();
          setLoading(false);

        },
        (errors: any) => {
          // setUploadErrors(errors);
        },
        () => {
          setLoading(false);
        }
      );
      setLoading(false);
    };
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
      innerRef={formRef}
      validationSchema={StudentValidationSchema}
    >
      {({ values, setFieldValue, resetForm, handleSubmit }) => (
        <UIModal
          visible={visible}
          closeModal={closeHandler}
          onClosed={resetForm}
          submitProps={{
            text: data ? 'Update' : 'Create',
            clickHandler: handleSubmit,
            buttonLoading: loading,
          }}
          cancelProps={{
            text: 'Cancel',
            clickHandler: closeHandler,
          }}
          className='institute-student-form'
        >
          <Form
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            <div className='institute-student-form__header'>
              <div className='institute-student-form__title'>
                {data ? 'Update Student' : 'Create New Student'}
              </div>
            </div>
            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Student Name</div>
              <InputField type='text' name='firstName' placeholder='Enter' />
            </div>

            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Email ID</div>
              <InputField type='text' name='email' placeholder='Enter' />
            </div>

            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Roll Number</div>
              <InputField type='text' name='rollNumber' placeholder='Enter' />
            </div>
            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Board</div>
              <DropdownField
                name='boardId'
                placeholder='Select board'
                disabled={false}
                options={boards}
                value={values?.boardId}
                onChange={(value) => {
                  setFieldValue('branchId', undefined);
                  setFieldValue('boardId', value);
                  fetchBranches(value);
                }}
                showSearch={false}
                optionFilterProp='label'
              />
            </div>
            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Branch</div>
              <DropdownField
                name='branchId'
                placeholder='Select'
                disabled={false}
                options={branches}
                value={values?.branchId}
                onChange={(value) => {
                  setFieldValue('branchClassRoomId', undefined)
                  setFieldValue('branchId', value);
                  setFieldValue('sectionId', undefined);
                  fetchBranchClassRooms(value);
                }}
                showSearch={false}
                optionFilterProp='label'
              />
            </div>
            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Class</div>
              <DropdownField
                name='branchClassRoomId'
                placeholder='Select'
                disabled={false}
                options={branchClassRoomsMeta}
                value={values?.branchClassRoomId}
                onChange={(value) => {
                  setFieldValue('sectionId', undefined);
                  setFieldValue('branchClassRoomId', value);
                  fetchSections(value)
                }}
                showSearch={false}
                optionFilterProp='label'
              />
            </div>
            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Section</div>
              <DropdownField
                name='sectionId'
                placeholder='Select section'
                options={sections}
                value={values?.sectionId}
                onChange={(value) => {
                  setFieldValue('sectionId', value);
                }}
                showSearch={false}
                optionFilterProp='label'
              />
            </div>
            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Phone Number</div>
              <InputField type='text' name='phoneNumber' placeholder='Enter' prefix={"+91"} />
            </div>
            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Date of birth</div>
              <DatePickerField
                name='date'
                placeholder='Select Date'
                value={values?.dob}
                format='YYYY-MM-DD'
                onSelect={(date) => {
                  setFieldValue('dob', date?.format('YYYY-MM-DD'));
                }}
              />
            </div>
            { !values?.id && <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Password</div>
              <InputField type='text' name='password' placeholder='Enter password' />
            </div>}
          </Form>
        </UIModal>
      )}
    </Formik>
  );
};

export default InstituteStudentForm;
